import type {BranchAndTagCountData} from '@github-ui/code-view-shared/contexts/BranchAndTagContext'
import type {RecentlyTouchedBranches} from '@github-ui/code-view-shared/contexts/RecentlyTouchedBranchesContext'
import type {DataRouterFileOverviewPayload} from '@github-ui/code-view-types'
import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {QueryRouteQueryType} from '@github-ui/react-core/future/data-router-types'
import {mainQuery} from '@github-ui/react-core/future/main-query'
import {queryFnFetch} from '@github-ui/react-core/future/query-fn-fetch'

import {codeViewAppBuilder} from '../config/app-builder'
import {latestCommitQuery} from '../queries/latest-commit-query'
import {sidebarAboutQuery} from '../queries/sidebar-about-query'
import {treeCommitInfoQuery} from '../queries/tree-commit-info-query'

export function buildCodeViewRepoRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('codeViewRepoRoute', {
    path: '/:owner/:repo',
    index: true,
    queries: [
      mainQuery<DataRouterFileOverviewPayload>(),
      sidebarAboutQuery,
      latestCommitQuery,
      treeCommitInfoQuery,
      {
        queryName: 'recentlyTouchedBranches',
        queryDeps: ({params}) => ({pathname: `/${params.owner}/${params.repo}/recently-touched-branches`}),
        queryFn: async queryKey => queryFnFetch<RecentlyTouchedBranches>(queryKey),
        type: QueryRouteQueryType.Deferred,
      },
      {
        queryName: 'branchAndTagCount',
        queryDeps: ({params}) => ({pathname: `/${params.owner}/${params.repo}/branch-and-tag-count`}),
        queryFn: async queryKey => queryFnFetch<BranchAndTagCountData>(queryKey),
        type: QueryRouteQueryType.Deferred,
      },
    ],
  })
}

export const codeViewRepoRoute = buildCodeViewRepoRoute(codeViewAppBuilder)
